import {
  FileSearch,
  ClipboardCheck,
  BookOpen,
  GraduationCap,
  BarChart3,
  Database,
  ArrowRightLeft,
  Shield,
  TrendingUp,
  Coffee,
  UserCheck,
  Map,
  Server,
  Hammer,
  FileUp,
  Workflow,
  Users,
  Calculator,
  FileScan,
  FileSpreadsheet
} from 'lucide-react';

// Maps icon string IDs from the server app catalog to Lucide React components
const iconMap = {
  'file-search': FileSearch,
  'clipboard-check': ClipboardCheck,
  'book-open': BookOpen,
  'graduation-cap': GraduationCap,
  'bar-chart-3': BarChart3,
  'database': Database,
  'arrow-right-left': ArrowRightLeft,
  'shield': Shield,
  'trending-up': TrendingUp,
  'coffee': Coffee,
  'user-check': UserCheck,
  'map': Map,
  'server': Server,
  'hammer': Hammer,
  'file-up': FileUp,
  'workflow': Workflow,
  'users': Users,
  'calculator': Calculator,
  'file-scan': FileScan,
  'file-spreadsheet': FileSpreadsheet,
};

/**
 * Resolve an icon identifier from the server to a React element.
 * Falls back to null for unknown IDs (card renders without icon).
 * Special case: 'pinnacle-logo' renders the logo <img> tag.
 */
export function resolveIcon(iconId, size = 22) {
  if (!iconId) return null;

  if (iconId === 'pinnacle-logo') {
    return <img src="/logos/pinnacle-logo.svg" alt="Pinnacle logo" style={{ width: size, height: size }} />;
  }

  const IconComponent = iconMap[iconId];
  if (!IconComponent) return null;

  return <IconComponent size={size} />;
}

/**
 * Resolve a tag icon identifier to a React element (smaller size).
 */
export function resolveTagIcon(iconId) {
  if (!iconId) return null;
  const IconComponent = iconMap[iconId];
  if (!IconComponent) return null;
  return <IconComponent size={16} />;
}

export default iconMap;
